<lex-doc-viewer-dialog>
  <div dialog-title>Settings</div>
  <div dialog-body>
    <div style="display:flex; flex-direction: column; margin: 14px 6px 24px; align-items: center; gap: 20px;">
      <div>
        <div style="display: flex; align-items: center;">
          <mat-icon *ngIf="!isDarkTheme" color="accent">light_mode</mat-icon>
          <mat-icon *ngIf="isDarkTheme">light_mode</mat-icon>
          <mat-slide-toggle #darkModeSwitch [(ngModel)]="isDarkTheme" (change)="toggleTheme($event)" [hideIcon]="true" class="slide-toggle-height-helper" style="padding-left: 4px;">
          </mat-slide-toggle>
          <mat-icon *ngIf="isDarkTheme" color="accent">dark_mode</mat-icon>
          <mat-icon *ngIf="!isDarkTheme">dark_mode</mat-icon>
        </div>
      </div>
      <div *inRole="[roles.Developer]">
        <lex-flat-button [label]="viewerLabel" [icon]="'fa-duotone fa-telescope'"
          (click)="togglePdfViewer()"></lex-flat-button>
      </div>
    </div>
  </div>
</lex-doc-viewer-dialog>